/**
 * Custom hook for loading service area zip codes from configuration
 * Uses React Query for automatic caching and deduplication
 */
import { useConfig } from './useConfig';

/**
 * Hook for getting service area zip codes from the database configuration
 * Returns the array of zip codes and loading/error states
 *
 * Uses 30-minute cache via useConfig to minimize API calls
 */
export function useServiceAreaZips() {
  const { values, loading, error } = useConfig('ServiceAreaZipCodes');

  return {
    serviceAreaZips: values,
    loading,
    error,
    /**
     * Check if a zip code is in the service area
     */
    isInServiceArea: (zipCode: string | undefined | null): boolean => {
      if (!zipCode || loading) {return false;}
      return values.includes(zipCode);
    }
  };
}
